module.exports = __webpack_public_path__ + "static/DeclineWebCover_LARGE-ef849f1c26473a6e38b0f039947a1a6e.jpeg";